import { Paper, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { SocItem } from "../../domain/SocItem";
import { ComplianceDeclaration } from "../sections/ComplianceDeclaration";
import { OrganisationalStabilityOfqual } from "../sections/OrganisationalStabilityOfqual";
import { FurtherQuestions } from "../sections/FurtherQuestions";
import { Kloe } from "../sections/Kloe";
import { SectionProps } from "../sections/SectionProps";

const useStyles = makeStyles((theme) => ({
  formHeading: {
    color: "#9f9f9f",
    fontSize: "1em",
    marginBottom: "30px",
    fontWeight: 600,
    position: "relative",
  },
  formSection: {
    padding: 30,
    boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "3px",
  },
}));

export const ItemDetailsOfqual: React.FC<{
  sectionProps: SectionProps<SocItem>;
}> = ({ sectionProps }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h6">Compliance declaration</Typography>

      <Paper className={classes.formSection}>
        <ComplianceDeclaration {...sectionProps} />
      </Paper>

      <Typography variant="h6">Organisational stability</Typography>

      <Paper className={classes.formSection}>
        <OrganisationalStabilityOfqual {...sectionProps} />
      </Paper>

      <Typography variant="h6">Key lines of enquiry - Third party agreements, including conflict of interest</Typography>

      <Paper className={classes.formSection}>
        <Kloe sectionProps={sectionProps} kloeType="Two" />
      </Paper>

      <Typography variant="h6">Key lines of enquiry - Apprenticeship End Point Assessments</Typography>

      <Paper className={classes.formSection}>
        <Kloe sectionProps={sectionProps} kloeType="Three" isRequired={false} />
      </Paper>

      <Typography variant="h6">Overall outcome</Typography>

      <Paper className={classes.formSection}>
        <FurtherQuestions {...sectionProps} />
      </Paper>
    </div>
  );
};
